import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';
import { fetchTickerData } from "../../api/tickersApi";  // Adjust path as necessary
import { selectAllTickerAttrs } from "../../store/slices/tickers.slice";  // Adjust path as necessary
import { mapListToColors } from "../../utils/colorUtils";  // Adjust path as necessary
import { getAllTickersFromSnapshots } from "./snapshotUtils";  // Adjust path as necessary

/**
 * Custom hook to handle fetching and mapping ticker styles to unique tickers
 * @param portfolioTimeSeries
 * @param attributeKey
 * @returns {{categoryMapping: {}, tickersToStyles: *}}
 */
const useTickerStyles = (portfolioTimeSeries, attributeKey) => {
    const dispatch = useDispatch();

    // Memoize unique tickers from the time series
    const uniqueTickers = useMemo(() => portfolioTimeSeries ? getAllTickersFromSnapshots(portfolioTimeSeries) : [], [portfolioTimeSeries]);

    // Retrieve ticker data from Redux store
    const tickerData = useSelector(state => selectAllTickerAttrs(state, uniqueTickers, [attributeKey]));

    // Compute styles for each ticker
    const tickersToStyles = useMemo(() => {
        return Object.entries(tickerData).reduce((acc, [k, v]) => {
            acc[k] = v?.tags?.style;
            return acc;
        }, {});
    }, [tickerData]);

    // Get unique styles and map them to colors
    const uniqueStyles = useMemo(() => _.uniq(Object.values(tickersToStyles)), [tickersToStyles]);
    const categoryMapping = useMemo(() => mapListToColors(uniqueStyles), [uniqueStyles]);

    // Fetch ticker data when unique tickers change
    useEffect(() => {
        if (uniqueTickers.length > 0) {
            dispatch(fetchTickerData({ symbols: uniqueTickers, fields: [attributeKey] }));
        }
    }, [uniqueTickers, dispatch]);

    return {
        tickersToStyles,
        categoryMapping
    };
};

export default useTickerStyles;
